module.exports = __webpack_public_path__ + "img/hans-granerud-l.ee5ac285.jpg";